export default "__VITE_ASSET__e53939fa__"